import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import vaccineStyle from "components/AddVaccineForm/AddVaccineForm.module.css";
import { FormField } from "components/form/FormField/FormField";
import { formatEircode } from "utils/validators";

/**
 * Post / Eircode input aligned with IntlPhoneField: explicit validation timing
 * (blur + onChange only while the field already has an error) so the resolver
 * does not fight register+setValue and UX stays responsive.
 */
export function PostCodeField({
  name = "postCode",
  label,
  placeholder = "",
  ariaRequired = false,
  // Eircode formatting on blur is right for an Irish address and wrong for any other:
  // formatEircode would reshape a UK or French postcode into something that is not what
  // the user typed (KIN-1650). Off for a non-Irish country, where the value is left alone.
  formatAsEircode = true,
}) {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const hadError = Boolean(errors[name]);
        return (
          <FormField name={name}>
            <label
              className={vaccineStyle.pregnancyFormLabel}
              htmlFor={name}
            >
              {label}
              {ariaRequired ? " *" : ""}
            </label>
            <input
              id={name}
              type="text"
              className="form-control"
              placeholder={placeholder}
              autoComplete="postal-code"
              aria-required={ariaRequired ? "true" : undefined}
              name={field.name}
              ref={field.ref}
              value={field.value ?? ""}
              onChange={(e) => {
                field.onChange(e.target.value);
                if (hadError) {
                  void trigger(name);
                }
              }}
              onBlur={(e) => {
                const val = e.target.value;
                if (val && formatAsEircode) {
                  field.onChange(formatEircode(val));
                }
                field.onBlur();
                void trigger(name);
              }}
            />
          </FormField>
        );
      }}
    />
  );
}
